export enum MultiplierType {
    "EMPLOYMENT_PERIOD" = "EMPLOYMENT_PERIOD", 
    "PUNCTUALITY" = "PUNCTUALITY", 
    "NUMBER_OF_DELIVERIES" = "NUMBER_OF_DELIVERIES", 
    "DELIVERIES_ON_TIME" = "DELIVERIES_ON_TIME", 
    "DELIVERIES_EARLY" = "DELIVERIES_EARLY", 
    "DELIVERIES_LATE" = "DELIVERIES_LATE"
}
